import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "none": "web_ui__Spacer__none",
  "x-small": "web_ui__Spacer__x-small",
  "small": "web_ui__Spacer__small",
  "regular": "web_ui__Spacer__regular",
  "medium": "web_ui__Spacer__medium",
  "large": "web_ui__Spacer__large",
  "larger": "web_ui__Spacer__larger",
  "x-large": "web_ui__Spacer__x-large",
  "x-larger": "web_ui__Spacer__x-larger",
  "x2-large": "web_ui__Spacer__x2-large",
  "x3-large": "web_ui__Spacer__x3-large",
  "x4-large": "web_ui__Spacer__x4-large",
  "x5-large": "web_ui__Spacer__x5-large",
  "x6-large": "web_ui__Spacer__x6-large",
  "space-0": "web_ui__Spacer__space-0",
  "space-50": "web_ui__Spacer__space-50",
  "space-100": "web_ui__Spacer__space-100",
  "space-150": "web_ui__Spacer__space-150",
  "space-200": "web_ui__Spacer__space-200",
  "space-300": "web_ui__Spacer__space-300",
  "space-400": "web_ui__Spacer__space-400",
  "space-500": "web_ui__Spacer__space-500",
  "space-600": "web_ui__Spacer__space-600",
  "space-700": "web_ui__Spacer__space-700",
  "space-900": "web_ui__Spacer__space-900",
  "space-800": "web_ui__Spacer__space-800",
  "space-1000": "web_ui__Spacer__space-1000",
  "space-1100": "web_ui__Spacer__space-1100",
  "space-1200": "web_ui__Spacer__space-1200",
  "space-1400": "web_ui__Spacer__space-1400",
  "space-1600": "web_ui__Spacer__space-1600",
  "space-2400": "web_ui__Spacer__space-2400",
  "space-3200": "web_ui__Spacer__space-3200",
  "vertical": "web_ui__Spacer__vertical",
  "horizontal": "web_ui__Spacer__horizontal"
};

var SPACER_SIZE_VALUES = ['x-small', 'small', 'regular', 'medium', 'large', 'larger', 'x-large', 'x-larger', 'x2-large', 'x3-large', 'x4-large', 'x5-large', 'x6-large', 'space-300', 'space-400', 'space-500', 'space-600', 'space-700', 'space-800', 'space-900', 'space-1000', 'space-1100', 'space-1200', 'space-1400', 'space-1600', 'space-2400', 'space-3200'];
var SPACER_ORIENTATION_VALUES = ['horizontal', 'vertical'];
/* ---------- Back-compat shim (deprecated) ---------- */
var SPACER_SIZE = {
  XSmall: 'x-small',
  Small: 'small',
  Regular: 'regular',
  Medium: 'medium',
  Large: 'large',
  Larger: 'larger',
  XLarge: 'x-large',
  XLarger: 'x-larger',
  X2Large: 'x2-large',
  X3Large: 'x3-large',
  X4Large: 'x4-large',
  X5Large: 'x5-large',
  X6Large: 'x6-large',
  Space300: 'space-300',
  Space400: 'space-400',
  Space500: 'space-500',
  Space600: 'space-600',
  Space700: 'space-700',
  Space800: 'space-800',
  Space900: 'space-900',
  Space1000: 'space-1000',
  Space1100: 'space-1100',
  Space1200: 'space-1200',
  Space1400: 'space-1400',
  Space1600: 'space-1600',
  Space2400: 'space-2400',
  Space3200: 'space-3200'
};
var SPACER_ORIENTATION = {
  Horizontal: 'horizontal',
  Vertical: 'vertical'
};
var cssClasses = classNames.bind(styles);
var SpacerBase = function SpacerBase(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    _ref$orientation = _ref.orientation,
    orientation = _ref$orientation === void 0 ? 'horizontal' : _ref$orientation,
    testId = _ref.testId,
    as = _ref.as;
  var spacerClass = cssClasses(size, orientation);
  if (as === 'span') return /*#__PURE__*/jsx("span", {
    className: spacerClass,
    "data-testid": testId
  });
  return /*#__PURE__*/jsx("div", {
    className: spacerClass,
    "data-testid": testId
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Spacer = _Object$assign(SpacerBase, {
  /**
   * @deprecated Use string literals instead: 'x-small', 'small', 'regular', 'medium', 'large', 'larger', 'x-large', 'x-larger', 'x2-large', 'x3-large', 'x4-large', 'x5-large', 'x6-large'
   */
  Size: SPACER_SIZE,
  /**
   * @deprecated Use string literals instead: 'horizontal', 'vertical'
   */
  Orientation: SPACER_ORIENTATION
});

export { SPACER_ORIENTATION, SPACER_ORIENTATION_VALUES, SPACER_SIZE, SPACER_SIZE_VALUES, Spacer, Spacer as default };
//# sourceMappingURL=Spacer.js.map
